/**
 * Created by Alex Aguilar on 6/23/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .controller('baseRatePassagesCtrl', baseRatePassagesCtrl)
        .controller('baseRatePassageEditCtrl', baseRatePassageEditCtrl);

    baseRatePassagesCtrl.$inject = ['linkService', 'taxes', 'baseRates', 'taxService', 'numberService'];
    baseRatePassageEditCtrl.$inject = ['baseRateService', '$stateParams','baseRate'];

    function baseRatePassagesCtrl(linkService, taxes,baseRates, taxService, numberService){
        var vm = this;
        vm.linkService = linkService;
        vm.populateBaseRatePassages = populateBaseRatePassages;
        vm.taxes = (taxes.data) ? taxes.data : [];
        vm.baseRates = (baseRates.data._embedded) ? baseRates.data._embedded.baserates : [];
        vm.baseRatePassages = [];
        vm.pages = baseRates.data.page;
        vm.searchRecords = "";

        populateBaseRatePassages();

        function populateBaseRatePassages() {
            angular.forEach(vm.baseRates, function (baseRate) {
                var passTaxes = getPassageTaxes(vm.taxes, baseRate);
                var typeTaxes =  getPassTaxesTotal(passTaxes, baseRate);
                vm.baseRatePassages.push({
                    minorWeightCargo: baseRate.minorWeightCargo,
                    tariffBaseCargo: baseRate.tariffBaseCargo,
                    tariffBasePassage: baseRate.tariffBasePassage,
                    tariffMinCargo: baseRate.minorWeightCargo,
                    grossRate: typeTaxes.total,
                    typeTaxes: typeTaxes.taxes,
                    taxes: getPassageTaxes(vm.taxes, baseRate),

                    _embedded: baseRate._embedded,
                    _links: baseRate._links
                });
            });
        }

        function getPassTaxesTotal(taxes, baseRate) {
            var result = [];
            var total = 0;
            var QM = calculateQM(taxes, 'QM', baseRate);
            for (var i = 0; i < taxes.length; i++) {
                var tax = taxes[i];
                if (tax !== null) {
                    var typeTax = taxService.getTypeTaxByType(tax.flightTypeTaxes, 'NATIONAL');
                    if (typeTax.calculationType === 'TARIFF_BASE') {
                        var amount  = 0;
                        if (tax.code === 'BO') {
                            amount = (baseRate.tariffBasePassage + QM) * (typeTax.amount/100);
                        } else if (tax.code === 'QM'){
                            amount = QM;
                        }
                        // var amount = baseRate.tariffBasePassage*(typeTax.amount/100);
                        result.push({
                            amount: numberService.roundHalfUp(amount)
                        })
                    } else if(typeTax.calculationType === 'FIXED_AMOUNT') {
                        if (tax.code === 'A7') {
                            amount = typeTax.amount;
                        }
                        result.push({
                            amount: numberService.roundHalfUp(amount)
                        })
                    }
                } else {
                    result.push({
                        amount: 0
                    })
                }
            }

            for (var j = 0; j < result.length; j++) {
                total = total + result[j].amount;
            }
            return {
                taxes: result,
                total: total + baseRate.tariffBasePassage
            }
        }

        function calculateQM(taxes, code, baseRate) {
            var totalQM = 0;
            for (var i = 0; i < taxes.length; i++) {
                var tax = taxes[i];
                if (tax.code === code) {
                    var typeTax = taxService.getTypeTaxByType(tax.flightTypeTaxes, 'NATIONAL');
                    totalQM = baseRate.tariffBasePassage*(typeTax.amount/100);
                    break;
                }
            }
            return  numberService.roundHalfUp(totalQM);
        }

        function getPassageTaxes(taxes, baseRate) {
            var resultTaxes = [];
            var initialsSplit = (baseRate._embedded.segment.initials).split('-');
            var segmentIata = initialsSplit[0].trim();
            for (var i = 0; i < taxes.length; i++) {
                var tax = taxes[i];
                if (tax.code !== 'A7') {
                    resultTaxes.push(tax);
                } else {
                    var isSegmentA7 = thereSegmentA7(tax.countryAirportTaxes, segmentIata);
                    if (isSegmentA7) {
                        resultTaxes.push(tax)
                    } else {
                        resultTaxes.push(null)
                    }
                }
            }
            return resultTaxes;
        }

        function thereSegmentA7(airportTaxes, iata) {
            var res = false;
            for (var i = 0; i < airportTaxes.length; i++) {
                if (airportTaxes[i].airport.iata === iata){
                    res = true;
                    break;
                }
            }
            return res;
        }
    }

    function baseRatePassageEditCtrl(baseRateService, $stateParams, baseRate){
        var vm = this;
        vm.baseRate = baseRate.data;

        vm.saveBaseRatePassage = function(isValid, baseRate){
            if(isValid){
                baseRateService.updateBaseRate($stateParams.id, baseRate, 'baseRatePassages');
            }
        }
    }

})();
